import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { AvailableActions } from '../../redux/actions/dataQuery'

import * as L from 'react-leaflet'

import Tree from 'antd/lib/tree'
import Alert from 'antd/lib/alert'
import Button from 'antd/lib/button'
import mbUrl from '../../modules/mbUrl'

import s from './style.scss'

// TODO: Detach from store. Make reusable via callback
// TODO bug low: clicking an area causes 2 api calls, where only 1 is needed

class GeoTree extends React.Component {

    state = {
        treeData: [
            {"title":"Europe","isLeaf":false,"key":6255148},
            {"title":"Asia","isLeaf":false,"key":6255147},
            {"title":"North America","isLeaf":false,"key":6255149},
            {"title":"South America","isLeaf":false,"key":6255150},
            {"title":"Africa","isLeaf":false,"key":6255146},
            {"title":"Oceania","isLeaf":false,"key":6255151},
            {"title":"Antarctica","isLeaf":false,"key":6255152}
        ],
        polygons: null,
        lastTreeNode: null,
        apiError: false
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (
            typeof this.props.store.geonameIds === 'undefined'
            || typeof this.props.store.geonameIds === 'undefined'
        ) {
            return
        }

        // Loads initial polygon
        // TODO low: also show selected area in tree
        if(
            prevProps.store.geonameIds !== undefined &&
            prevProps.store.geonameIds.length !== this.props.store.geonameIds.length)
        {
            this.onSelect([...this.props.store.geonameIds])
        }

    }

    onLoadData = treeNode => {

        this.setState({
            lastTreeNode: treeNode,
            apiError: false
        })

        // load tree branch
        return new Promise(resolve => {
            if (treeNode.props.children) {
                resolve()
                return
            }
            let geonameid = treeNode.props.dataRef.key

            const url = mbUrl.getSigned('/polygon/geotree', 'geonameid=' + geonameid)

            fetch(url)
                .then(response => {
                    return response.json()
                })
                .then(json => {
                    if('error_message' in json) {
                        // TODO: retry
                        this.setState({ apiError: json.error_message })
                        return
                    }

                    treeNode.props.dataRef.children = json
                    this.setState({
                        treeData: [...this.state.treeData],
                    })
                    resolve()
                })
                .catch(e => {
                    console.log(e)
                })

        })
    }
    
    onSelect = ids => {
        
        if(typeof ids === 'undefined' || ids.length === 0) {
            this.setState({ polygons: null })
            return
        }

        this.setState({ loading: true })

        this.props.setDataQuery({ geonameIds: ids })

        const fetchPromises = []
        const polygons = []

        ids.forEach(geonameId => {
            const url = mbUrl.getSigned('/polygon/get', 'geonameid=' + geonameId)

            // load polygon
            fetchPromises.push(
                fetch(url)
                    .then(response => {
                        return response.json();
                    })
                    .then(json => {
                        if('error_message' in json) {
                            if(json.error_message.indexOf('Could not find polygon') !== -1) {
                                // TODO: maybe replace alert
                                alert('No polygon available for this area. Select parent or draw polygon.')
                            } else {
                                this.setState({apiError: json.error_message})
                            }
                            return
                        } else {
                            polygons.push(<L.GeoJSON data={json} key={geonameId} />)
                        }
                    })
                    .catch(e => {
                        console.log(e)
                    })
            )

        })

        Promise.all(fetchPromises)
            .then(() => {

            // TODO: update form legacy string ref
            this.setState({
                    polygons,
                    loading: false
                },
                () => {
                    this.refs.areaMap.leafletElement.fitBounds(
                        this.refs.areaPolygon.leafletElement.getBounds()
                )
                this.forceUpdate()
            })
        })


    }

    renderTreeNodes = data => {
        return data.map((item) => {
            if (item.children) {
                return (
                    <Tree.TreeNode title={item.title} key={item.key}>
                        {this.renderTreeNodes(item.children)}
                    </Tree.TreeNode>
                );
            }
            return <Tree.TreeNode {...item} dataRef={item} />;
        });
    }

    render() {
        return (
            <div className={s.politicalArea}>
                <div className={s.geoTree}>
                    { !this.state.apiError ? (
                        <Tree
                            loadData={this.onLoadData}
                            onSelect={this.onSelect}
                            multiple
                            disabled={this.state.loading}
                        >
                            { this.renderTreeNodes(this.state.treeData)}
                        </Tree>
                    ) : (
                        <Alert
                            message="Error"
                            description={
                                <div>
                                    <p>An error occurred while receiving data
                                        from the server. Please select area again.
                                        If the problem continues please report
                                        to info@meteoblue.com.
                                    </p>
                                    <p>
                                        Error message: {this.state.apiError}
                                    </p>
                                    {/* TODO: add try again option */}
                                    <Button onClick={ () => {
                                        this.setState({apiError: false})
                                    }}>Close</Button>
                                </div>
                            }
                            type="error"
                        />
                    )}
                </div>
                {/* TODO: replace legacy string refs */}
                {/* Warning: Min and max map zoom must be set. Otherwise map will crash on component unmount.
                    No idea why. */}
                <L.Map style={{height: '600px'}} center={[47,7]} zoom={7} minZoom={3} maxZoom={15} ref='areaMap' >
                    { this.props.layers.map(layer => <L.TileLayer {...layer} />) }
                    <L.FeatureGroup ref='areaPolygon'>
                        { this.state.polygons }
                    </L.FeatureGroup>
                </L.Map>
            </div>
        );
    }
}

GeoTree.propTypes = {
    layers: PropTypes.array,
}

const mapStateToProps = state => {
    return {
        store: state.dataQuery,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        setDataQuery: (dataQuery) => dispatch({
            type: AvailableActions.SET_DATA_QUERY,
            payload: dataQuery
        })
    }
};

export default connect(mapStateToProps,mapDispatchToProps)(GeoTree)